import { Lift, LiftInput } from '../types'
import createAPIClient from '../services/apiClient'
import { AxiosRequestConfig } from 'axios'

const api = createAPIClient('/v2')

export async function getLifts(config?: AxiosRequestConfig): Promise<Lift[]> {
  const response = await api.get('/lifts', config)

  return response.data
}

export async function getLiftsByProjectId(
  projectId: number,
  config?: AxiosRequestConfig
): Promise<Lift[]> {
  const response = await api.get(`/projects/${projectId}/lifts`, config)

  return response.data
}

export async function getLift(id: number, config?: AxiosRequestConfig): Promise<Lift> {
  const response = await api.get(`/lifts/${id}`, config)

  return response.data
}

export async function createLift(input: LiftInput, config?: AxiosRequestConfig): Promise<Lift> {
  const response = await api.post('/lifts', input, config)

  return response.data
}

export async function updateLift(
  id: number,
  input: LiftInput,
  config?: AxiosRequestConfig
): Promise<Lift> {
  const response = await api.put(`/lifts/${id}`, input, config)

  return response.data
}

export async function deleteLift(id: number, config?: AxiosRequestConfig): Promise<void> {
  await api.delete(`/lifts/${id}`, config)
}

export default {
  getLifts,
  getLiftsByProjectId,
  getLift,
  createLift,
  updateLift,
  deleteLift
}
